import { UseCommercialConsultationsResponse } from '../../../../../../hooks/fetchers/useCommercialInProgressConsultations/useCommercialInProgressConsultations.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../utils/api/endpoints/consultationsEndpoints';
import { SearchInProgressConsultationsCOMQuery } from './DashboardIPConsultsCOMTable.types';

const SEARCH_IN_PROGRESS_CONSULTATIONS_PREFIX = '[searchConsultationsQuery]';

export const SEARCH_IN_PROGRESS_CONSULTATIONS_QUERY_KEY = 'SEARCH_IN_PROGRESS_CONSULTATIONS';

export const searchInProgressConsultationsCOMQuery = async ({
  search,
  params,
}: SearchInProgressConsultationsCOMQuery) => {
  console.log(SEARCH_IN_PROGRESS_CONSULTATIONS_PREFIX, `Searching "${search}" in consultations...`);

  const response = await CONSULTATIONS_ENDPOINTS.searchCommercialInProgressConsultations(
    search,
    params
  );

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_IN_PROGRESS_CONSULTATIONS_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_IN_PROGRESS_CONSULTATIONS_PREFIX, `Searched "${search}" in consultations.`);

  return json as UseCommercialConsultationsResponse;
};
